module.exports = __webpack_public_path__ + "img/w22b.721f1f6e.jpg";